import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box, TextField, Button, Typography, Alert, CircularProgress,
} from '@mui/material';
import { studentLogin } from '../studentPortalApi';
import { fieldSxFromTheme, getPortalTheme } from '../portalTheme';

const IS_OPEN_GEMARA = (process.env.REACT_APP_EXAM_MODE || 'predefined') === 'open-gemara';

const LoginStep = ({ onSuccess, onRegisterClick, theme }) => {
  const t = theme || getPortalTheme(false);
  const fieldSx = fieldSxFromTheme(t);
  const [phone, setPhone] = useState('');
  const [personalCode, setPersonalCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await studentLogin(phone.trim(), personalCode.trim());
      onSuccess(data.member);
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאת התחברות');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 420, mx: 'auto' }}>
      <Typography
        variant="h5"
        sx={{
          color: '#f5f0e6',
          fontFamily: '"Frank Ruhl Libre", "David Libre", serif',
          fontWeight: 700,
          mb: 1,
          textAlign: 'center',
        }}
      >
        ברוכים הבאים
      </Typography>
      <Typography sx={{ color: 'rgba(245,240,230,0.75)', mb: 3, textAlign: 'center', fontSize: '0.95rem' }}>
        להתחלת הרישום הזינו מספר טלפון וקוד אישי.
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        fullWidth
        label="מספר טלפון"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        margin="normal"
        required
        inputProps={{ inputMode: 'tel', dir: 'ltr' }}
        sx={fieldSx}
      />
      <TextField
        fullWidth
        label="קוד אישי"
        value={personalCode}
        onChange={(e) => setPersonalCode(e.target.value)}
        margin="normal"
        required
        inputProps={{ inputMode: 'numeric', dir: 'ltr' }}
        sx={fieldSx}
      />

      <Button
        type="submit"
        fullWidth
        disabled={loading}
        sx={{
          mt: 3,
          minHeight: 48,
          py: 1.4,
          fontWeight: 700,
          fontSize: { xs: '1rem', sm: '1.05rem' },
          borderRadius: 2,
          color: t.ctaColor,
          background: t.ctaBg,
          boxShadow: `0 4px 20px ${t.accentMuted}`,
          '&:hover': { filter: 'brightness(1.06)' },
        }}
      >
        {loading ? <CircularProgress size={24} sx={{ color: t.ctaColor }} /> : 'כניסה ←'}
      </Button>

      {onRegisterClick && (
        <Button
          type="button"
          fullWidth
          onClick={onRegisterClick}
          sx={{
            mt: 2,
            minHeight: 48,
            py: 1.2,
            fontWeight: 700,
            borderRadius: 2,
            color: t.accent,
            border: `1px solid ${t.accentBorder}`,
            '&:hover': {
              borderColor: t.accentSoft,
              background: t.accentMuted.replace('0.35', '0.1').replace('0.38', '0.1'),
            },
          }}
        >
          רישום לנבחן חדש
        </Button>
      )}

      {!IS_OPEN_GEMARA && (
        <Button
          component={RouterLink}
          to="/gabbai"
          fullWidth
          sx={{
            mt: 2,
            minHeight: 48,
            py: 1.2,
            fontWeight: 700,
            borderRadius: 2,
            color: 'rgba(245,240,230,0.85)',
            border: `1px solid ${t.accentBorderSoft || t.accentBorder}`,
            '&:hover': {
              borderColor: t.accentSoft,
              background: 'rgba(255,255,255,0.04)',
            },
          }}
        >
          כניסת גבאים
        </Button>
      )}
    </Box>
  );
};

export default LoginStep;
